import { Page } from "../page.js";

let template = require("./faq.twig");

export class Faq extends Page {
  constructor() {
    super();
    this.dom = $(twig({ data: template }).render({}));
  }

  getFaq() {
    $.ajax({
      url: "api/faq",
      method: "GET",
      dataType: "json",
    }).then((data) => {
      const rawFAQ = data?.faq || "";
      if (!rawFAQ) {
        $("#FAQ_Content").html("<p>No info</p>");
        return;
      }

      const $tempDiv = $("<div>").html(rawFAQ);

      // Remove all inline styles except color (skip tables completely)
      $tempDiv
        .find("*")
        .not("table, table *")
        .each(function () {
          const color = $(this).css("color");
          $(this).removeAttr("style");
          if (color) $(this).addClass("faq-color").css("color", color);
        });

      // Remove empty paragraphs/divs
      $tempDiv
        .find("p, div")
        .filter(function () {
          return $(this).text().trim() === "";
        })
        .remove();

      // Remove elements before first Q: or A:
      let firstIndex = -1;
      $tempDiv.find("p, div").each(function (i) {
        const text = $(this).text().trim();
        if (
          firstIndex === -1 &&
          (text.startsWith("Q:") || text.startsWith("A:"))
        ) {
          firstIndex = i;
        }
      });
      if (firstIndex > 0) {
        $tempDiv.find("p, div").slice(0, firstIndex).remove();
      }

      const $final = $("<div>");
      let $currentItem = null;
      let answerBuffer = "";

      function flushAnswerBuffer() {
        if ($currentItem && answerBuffer) {
          const $a = $("<p>").addClass("faq-answer").html(answerBuffer);

          // Remove <font> tags but keep inner HTML
          $a.find("font").each(function () {
            $(this).replaceWith($(this).html());
          });

          $currentItem.append($a);
          answerBuffer = "";
        }
      }

      $tempDiv.children().each(function () {
        const $el = $(this);
        // Skip rendering img tags
        if ($el.is("img")) {
          return;
        }
        const html = $el.html()?.trim() || "";
        const text = $el.text()?.trim() || "";

        if ($el.is("p, div")) {
          if (text.startsWith("Q:")) {
            flushAnswerBuffer();
            $currentItem = $("<div>").addClass("faq-item-wrapper");
            const $q = $("<p>").addClass("faq-question").html(html);
            $currentItem.append($q);
            $final.append($currentItem);
          } else if (text.startsWith("A:")) {
            const $temp = $("<div>").html(html);
            const firstChild = $temp.contents().first();
            const startsWithBold = firstChild.is("b, strong");
            if (startsWithBold && answerBuffer) {
              answerBuffer += "<br>";
            }
            answerBuffer += html;
          } else {
            flushAnswerBuffer();
            if ($currentItem) {
              const $p = $("<p>").addClass("faq-answer").html(html);
              $currentItem.append($p);
            } else {
              $final.append($("<p>").addClass("faq-answer").html(html));
            }
          }
        } else if ($el.is("table")) {
          flushAnswerBuffer();

          // Keep table EXACTLY as-is (with all inline styles)
          const $table = $el.clone(true, true);
          $final.append($table);
        } else {
          flushAnswerBuffer();
          const $clone = $el
            .clone()
            .find("*")
            .each(function () {
              const color = $(this).css("color");
              $(this).removeAttr("style");
              if (color) $(this).css("color", color);
            });
          $final.append($clone);
        }
      });

      flushAnswerBuffer();

      // Set hyperlink attributes
      $final.find("a").attr({
        target: "_blank",
        rel: "noopener noreferrer",
      });

      // Render
      $("#FAQ_Content").html($final.html());
    });
  }

  initFaqSearch() {
    const $searchInput = $("#faqSearch");
    const $faqContent = $("#FAQ_Content");

    if (!$searchInput.length || !$faqContent.length) return;

    const showNavButtons = false; // always true

    // Add match counter (only one instance)
    let $matchCount = $("#matchCount");
    if (!$matchCount.length) {
      $matchCount = $("<div id='matchCount' class='faq-match-count'></div>");
      $searchInput.after($matchCount);
    }

    let $prevBtn, $nextBtn;
    if (showNavButtons) {
      // Up and Down arrow buttons with modern styling
      $prevBtn = $(
        "<button type='button' class='faq-nav-btn' title='Previous Match'>↑</button>"
      );
      $nextBtn = $(
        "<button type='button' class='faq-nav-btn' title='Next Match'>↓</button>"
      );

      $matchCount.append($prevBtn, $nextBtn); // append inside counter div
    }

    const markInstance = new window.Mark($faqContent[0]);
    let currentIndex = -1;
    let $matches = $();

    // Highlight matches
    const highlightText = (searchText) => {
      markInstance.unmark({
        done: () => {
          if (!searchText) {
            $matches = $();
            currentIndex = -1;
            updateMatchCount();
            return;
          }

          markInstance.mark(searchText, {
            separateWordSearch: false,
            caseSensitive: false,
            element: "span",
            className: "highlight",
            each: (el) => {
              el.style.backgroundColor = "yellow";
            },
            done: () => {
              $matches = $faqContent.find("span.highlight");
              currentIndex = $matches.length ? 0 : -1;
              updateMatchCount();
              scrollToCurrent();
            },
          });
        },
      });
    };

    // Scroll to current match
    const scrollToCurrent = () => {
      $matches.css("background-color", "yellow"); // reset all

      if (currentIndex >= 0 && $matches[currentIndex]) {
        const $current = $($matches[currentIndex]);
        $current.css("background-color", "orange"); // highlight current

        const offsetTop = $current.offset().top;
        const faqTop = $faqContent.offset().top;
        const faqHeight = $faqContent.height();
        const scrollPos =
          offsetTop -
          faqTop +
          $faqContent.scrollTop() -
          faqHeight / 2 +
          $current.height() / 2;

        $faqContent.animate({ scrollTop: scrollPos }, 200);
      }

      updateMatchCount();
    };

    // Update match counter
    const updateMatchCount = () => {
      const searchVal = $searchInput.val().trim();
      if (!searchVal || $matches.length === 0) {
        $matchCount.hide();
        if (showNavButtons) {
          $prevBtn.css('display', 'none');
          $nextBtn.css('display', 'none');
        }
      } else {
        $matchCount
          .show()
          .contents()
          .filter(function () {
            return this.nodeType === 3; // text nodes
          })
          .remove(); // remove previous text
        $matchCount.prepend(
          document.createTextNode(
            `${currentIndex + 1} of ${$matches.length} matches `
          )
        );
        if (showNavButtons && $matches.length > 0) {
          $prevBtn.css('display', 'flex');
          $nextBtn.css('display', 'flex');
        } else {
          $prevBtn.css('display', 'none');
          $nextBtn.css('display', 'none');
        }
      }
    };

    // Navigation functions
    const nextMatch = () => {
      if (!$matches.length) return;
      currentIndex = (currentIndex + 1) % $matches.length;
      scrollToCurrent();
    };

    const prevMatch = () => {
      if (!$matches.length) return;
      currentIndex = (currentIndex - 1 + $matches.length) % $matches.length;
      scrollToCurrent();
    };

    // Clear search + highlights
    const clearSearch = () => {
      $searchInput.val("");
      markInstance.unmark();
      $matches = $();
      currentIndex = -1;
      updateMatchCount();
    };

    // Input listener
    $searchInput.on("input", () => {
      const searchText = $searchInput.val().trim();
      highlightText(searchText);
    });

    // Enter / Shift+Enter navigation + Esc clear
    $searchInput.on("keydown", (e) => {
      if (e.key === "Enter") {
        e.preventDefault();
        e.shiftKey ? prevMatch() : nextMatch();
      } else if (e.key === "Escape") {
        clearSearch();
        $searchInput.focus();
      }
    });

    // Ctrl+F focuses custom search field
    $(document).on("keydown", (e) => {
      if (e.ctrlKey && e.key.toLowerCase() === "f") {
        e.preventDefault();
        $searchInput.focus();
        $searchInput.select();
      }
    });

    // Attach button clicks
    if (showNavButtons) {
      $prevBtn.on("click", prevMatch);
      $nextBtn.on("click", nextMatch);
    }
  }

  ready() {
    this.getFaq();
    this.initFaqSearch();
  }
}
